export const agentsModule = {
    slug: 'agents',
    label: 'Agents',
    description: 'Manage agents, credentials, and module configurations.',
    icon: 'Bot',
};
//# sourceMappingURL=agents.js.map